export const languageLabels = {
  DA: 'Danish',
  NL: 'Dutch',
  EN: 'English',
  FR: 'French',
  DE: 'German',
  HI: 'Hindi',
  IT: 'Italian',
  JA: 'Japanese',
  KO: 'Korean',
  ZH: 'Mandarin',
  NO: 'Norwegian',
  PL: 'Polish',
  PT: 'Portuguese',
  RU: 'Russian',
  ES: 'Spanish',
  SV: 'Swedish',
};

export const languageOptions = [
  'DA',
  'NL',
  'EN',
  'FR',
  'DE',
  'HI',
  'IT',
  'JA',
  'KO',
  'ZH',
  'NO',
  'PL',
  'PT',
  'RU',
  'ES',
  'SV',
];
export const DEFAULT_LANGUAGE = 'EN';
